import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';
import ButtonBlockData from './Data';
import ButtonBlockView from './View';

const ButtonBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <ButtonBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <ButtonBlockData data={data} block={block} onChangeBlock={onChangeBlock} />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(ButtonBlockEdit);
